import { RootState } from 'rootReducer';

export const tvPanelSel = (state: RootState) => state.tvPanelModuleReducer.tvPanelReducer;
